import { api } from './api';

export interface User {
  id: string;
  email: string;
  name: string | null;
  role: 'ADMIN' | 'STAFF' | 'VIEWER';
}

export interface LoginResponse {
  user: User;
  accessToken: string;
  refreshToken: string;
}

export interface LoginDto {
  email: string;
  password: string;
}

export interface RegisterDto {
  email: string;
  password: string;
  name: string;
  role?: 'ADMIN' | 'STAFF' | 'VIEWER';
}

export interface ChangePasswordDto {
  currentPassword: string;
  newPassword: string;
}

class AuthService {
  private readonly basePath = '/auth';

  /**
   * Login del usuario
   */
  async login(credentials: LoginDto): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>(`${this.basePath}/login`, credentials);
    return response.data;
  }

  /**
   * Registro de nuevo usuario (solo ADMIN)
   */
  async register(data: RegisterDto): Promise<User> {
    const response = await api.post<User>(`${this.basePath}/register`, data);
    return response.data;
  }

  /**
   * Obtener perfil del usuario actual
   */
  async getProfile(): Promise<User> {
    const response = await api.get<User>(`${this.basePath}/profile`);
    return response.data;
  }

  /**
   * Cambiar contraseña
   */
  async changePassword(data: ChangePasswordDto): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>(`${this.basePath}/change-password`, data);
    return response.data;
  }

  /**
   * Refrescar token de acceso
   */
  async refreshToken(refreshToken: string): Promise<{ accessToken: string }> {
    const response = await api.post<{ accessToken: string }>(`${this.basePath}/refresh`, {
      refreshToken,
    });
    return response.data;
  }

  /**
   * Logout
   */
  async logout(refreshToken?: string): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>(`${this.basePath}/logout`, {
      refreshToken,
    });
    return response.data;
  }

  /**
   * Verificar si el token es válido
   */
  async verify(): Promise<User> {
    const response = await api.get<{ valid: boolean; user: User }>(`${this.basePath}/verify`);
    return response.data.user;
  }
}

export const authService = new AuthService();
